import { View } from "binder"
import { UsageAmount, UsageAmountManipulationViewModel } from "./usageAmountManipulation-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class UsageAmountManipulationView extends View<UsageAmountManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-0622B9C1-6CC2-40BB-B7F5-04A4F6027CD8"
    }
    loadHtml(): string {
        let element = require('./usageAmountManipulation.html').default;
        let style = require('./usageAmountManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set usageAmounts(v: UsageAmount) { this._usageAmounts = v; } public get usageAmounts(): UsageAmount { return this._usageAmounts; } private _usageAmounts: UsageAmount;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
